import { PATHS } from "@/lib/config/routesConfig";

type ThreadChatOwner = {
  threadId: string;
  assistantId?: string | null;
};

export const getThreadChatPath = ({
  threadId,
  assistantId,
}: ThreadChatOwner): string | null =>
  assistantId ? `${PATHS.ASSISTANTS}/${assistantId}/chat/${threadId}` : null;
